import gql from 'graphql-tag'

export const LOG_SERVICE_CATEGORY = gql`
  query ServiceCategoryAuditLogs($filter: CommonAuditLogsFilter) {
    serviceCategoryAuditLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceCategoryAuditLogs {
        data {
          time
          entity
          action
          detail
          user
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const LOG_SERVICE_ACTION = gql`
  query ServiceActionAuditLogs($filter: CommonAuditLogsFilter) {
    serviceActionAuditLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceActionAuditLogs {
        data {
          time
          entity
          action
          detail
          user
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const LOG_SERVICES = gql`
  query ServiceAuditLogs($filter: ServiceAuditLogsFilter) {
    serviceAuditLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceAuditLogs {
        data {
          time
          entity
          action
          detail
          user
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const LOG_SERVICE_SCHEDULES = gql`
  query ServiceScheduleAuditLogs($filter: ServiceScheduleAuditLogsFilter!) {
    serviceScheduleAuditLogs(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      serviceScheduleAuditLogs {
        data {
          time
          entity
          action
          detail
          user
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
